// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/CompletedJobsList.scss
// module id = ./src/styles/CompletedJobsList.scss
// module chunks = 0